// extracted by mini-css-extract-plugin
export default {"createCenter":"create-center_createCenter__dRiGf","header":"create-center_header__9LoUP","backward":"create-center_backward__XTaSk","rotate":"create-center_rotate__9D59W"};